// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d26eb1c4","453":"5484c5fd","455":"c2ce4509"}[chunkId] + ".chunk.js";
};